
<template>
  <div class="etkinlikler">
    <AppMain>


      <div class="container-fluid">
        <div class="row">
          <div class="col-xxl-12">
            <div class="inner-contents">



            

              <div class="nk-block-head nk-block-head-sm">
                <div class="nk-block-between">
                  <div class="nk-block-head-content">
                    <h3 class="nk-block-title page-title">Etkinlikler</h3>
                    <div class="nk-block-des text-soft">
                      <p>Tfon Makine</p>
                    </div>
                  </div>
                  <div class="nk-block-head-content">
                    <div class="toggle-wrap nk-block-tools-toggle"><a href="#"
                        class="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em
                          class="icon ni ni-menu-alt-r"></em></a>
                      <div class="toggle-expand-content" data-content="pageMenu">
                        <ul class="nk-block-tools g-3">

                          <li><a href="#" v-if="yetki_kontrol('etkinlik_ekle')" @click="etkinlikler_ekle"
                              class="btn btn-white btn-outline-light"><em class="icon ni ni-plus"></em><span>Etkinlik
                                Ekle</span></a>
                          </li>
                          <li class="nk-block-tools-opt">
                            <div class="drodown"><a href="#" class="dropdown-toggle btn btn-icon btn-white btn-outline-light"
                                data-bs-toggle="dropdown"><em class="icon ni ni-download-cloud"></em></a>
                              <div class="dropdown-menu dropdown-menu-end">
                                <ul class="link-list-opt no-bdr">
                                  <li><a href="#" v-if="yetki_kontrol('etkinlik_ekle')" @click="excelindir"><span>Excel
                                        İndir</span></a></li>
                                  <li><a href="#" v-if="yetki_kontrol('etkinlik_ekle')"
                                      @click="excelmodal_ac"><span>Excel Yükle</span></a></li>
                                </ul>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



              <div class="card-inner position-relative card-tools-toggle">
                <div class="card-title-group" >
                  <div class="card-tools"></div>
                  <div class="card-tools me-n1">
                    <ul class="btn-toolbar gx-1">
                      <li>   <input type="text" name="search" v-model="etkinlikler.arananKelime" class=" form-control aramaText "
                placeholder="Arama"></li>
                      <li class="btn-toolbar-sep"></li>
                      <li>
                        <div class="toggle-wrap"><a href="#" class="btn btn-icon btn-trigger toggle"
                            data-target="cardTools"><em class="icon ni ni-menu-right"></em></a>
                          <div class="toggle-content" data-content="cardTools">
                            <ul class="btn-toolbar gx-1">
                              <li class="toggle-close"><a href="#" class="btn btn-icon btn-trigger toggle"
                                  data-target="cardTools"><em class="icon ni ni-arrow-left"></em></a></li>
                           
                              <li>
                                <div class="dropdown"><a href="#" class="btn btn-trigger btn-icon dropdown-toggle"
                                    data-bs-toggle="dropdown"><em class="icon ni ni-setting"></em></a>
                                  <div class="dropdown-menu dropdown-menu-xs dropdown-menu-end">
                                    <ul class="link-check">
                                      <li><span>Kayıt Sayısı</span></li>
                                      <li :class="{ active: etkinlikler.sayfadaKayit==10,'link':true }"><a href="#" @click="etkinliklerSayfadaKayitDegistir(10)" >10</a></li>
                                      <li :class="{ active: etkinlikler.sayfadaKayit==20,'link':true }"><a href="#" @click="etkinliklerSayfadaKayitDegistir(20)">20</a></li>
                                      <li :class="{ active: etkinlikler.sayfadaKayit==50,'link':true }"><a href="#" @click="etkinliklerSayfadaKayitDegistir(50)">50</a></li>
                                    </ul>
                                
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="card-search search-wrap" data-search="search">
                  <div class="card-body">
                    <div class="search-content"><a href="#" class="search-back btn btn-icon toggle-search"
                        data-target="search"><em class="icon ni ni-arrow-left"></em></a><input type="text"
                        class="form-control border-transparent form-focus-none"
                        placeholder="Search by user or email"><button class="search-submit btn btn-icon"><em
                          class="icon ni ni-search"></em></button></div>
                  </div>
                </div>
              </div>
              <etkinlikCard :etkinlikler="etkinlikler" :duzenle="etkinlikler_duzenle" :detay="etkinlikler_detay"
                :formKaydetSonrasi="etkinliklerYenile" @update:etkinlikler="etkinliklerGuncelle" />


            </div>
          </div>

        
          <div class="nk-add-product toggle-slide toggle-slide-right toggle-screen-any " :class="{'content-active':this.etkinlikler.modal}" data-content="addProduct" data-toggle-screen="any" data-toggle-overlay="true" data-toggle-body="true" data-simplebar="init">
            <div class="simplebar-wrapper" style="margin: -24px;">
                <div class="simplebar-height-auto-observer-wrapper"><div class="simplebar-height-auto-observer"></div></div>
                <div class="simplebar-mask">
                    <div class="simplebar-offset" style="right: 0px; bottom: 0px;">
                        <div class="simplebar-content-wrapper" tabindex="0" role="region" aria-label="scrollable content" style="height: 100%;">
                            <div class="simplebar-content" style="padding: 24px;">
                              
                                <div class="nk-block">
                                    <div class="row g-3">

                                      <etkinlikForm :formIslem="etkinlikler.islem" :formData="etkinlikler.secili"
                            :formKaydetSonrasi="etkinliklerYenile" :formIptal="etkinlikler_iptal" />

                                      
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="simplebar-placeholder" style="width: auto; height: 698px;"></div>
            </div>
            <div class="simplebar-track simplebar-horizontal" style="visibility: hidden;"><div class="simplebar-scrollbar" style="width: 0px; display: none;"></div></div>
            <div class="simplebar-track simplebar-vertical" style="visibility: hidden;"><div class="simplebar-scrollbar" style="height: 0px; display: none;"></div></div>
        </div>






        </div>
      </div>

      <div class="modal fade modal-close-out show" style="display: block;" v-if="excelmodal">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Excel Yükleme </h5>
            <a href="#" class="btn-close" @click="excelmodal_kapat"></a>
            </div>
            <div class="modal-body">

              <div class="form-group">
                <label for="excel">Excel (*.xlsx):</label>
                <input type="file" class="form-control" id="excel" name="excel" accept=".xlsx"
                  v-on:change="dosyaSecExcel" />
              </div>
              <div class="form-group">
                <label for="gorseller">Görseller (*.zip):</label>
                <input type="file" class="form-control" id="gorseller" name="gorseller" accept=".zip"
                  v-on:change="dosyaSecGorseller" />
              </div>

              <div class="progress" v-if="isUploading">
                {{ uploadFileName }} Dosyası Yükleniyor
                <div class="progress-bar" role="progressbar" :style="{ width: `${uploadProgress}%` }">
                  {{ uploadProgress }}%
                </div>
              </div>

              <div class="progress" v-if="excelVeriIslem">
                Excelden Veriler İşleniyor
                <div class="progress-bar" role="progressbar" :style="{ width: `${excelprosesbar}%` }">
                  {{ excelprosesbar }}%
                </div>
              </div>

              <br>
              <a  href="#" class="btn btn-outline-primary w-20" @click="excelmodal_kapat">İptal</a>
              <a  href="#" class="btn btn-primary w-80" @click="excelyukle">Kaydet</a>

            </div>
          </div>

        </div>
      </div>


    </AppMain>
  </div>
</template>

<script>
import axiosCustom from "@/services/axiosCustom";
import { yetkiKontrol } from '@/services/yetkiKontrol';
import AppMain from "@/components/AppMain.vue";
import etkinlikCard from "@/components/etkinlikler/etkinlikCard.vue";
import etkinlikForm from "@/components/etkinlikler/etkinlikForm.vue";

export default {
  name: "etkinliklerView",
  components: {
    AppMain,
    etkinlikCard,
    etkinlikForm,
  },
  data() {
    return {
      etkinlikler: {
        tumu:[],
        secili:null,
        seciliSayfa:1,
        sayfadaKayit:10,
        arananKelime:"",
        islem:'',
        modal:false,
      },
    };
  },
 
  mounted() {
    this.etkinliklerGetir();
  },
  methods: {
    yetki_kontrol(yetki){
      return yetkiKontrol(yetki);
    },
    etkinliklerGetir() {
      axiosCustom
        .get("etkinlikler")
        .then((response) => {
          this.etkinlikler.tumu = response.data;
        })
        .catch((error) => {
          console.error("Veri çekme hatası: ", error);
        });
    },
    etkinliklerYenile() {
      this.etkinliklerGetir();
      this.etkinlikler.modal=false;
      this.etkinlikler.islem = "";
    },
    etkinliklerGuncelle(veriler) {
      this.etkinlikler = veriler;
    },
   
    etkinlikler_ekle() {
      this.etkinlikler.secili = {};
      this.etkinlikler.islem = "ekle";
      this.etkinlikler.modal=true;
    },
    etkinlikler_duzenle(etkinlik) {
      this.etkinlikler.secili = etkinlik;
      this.etkinlikler.islem = "duzenle";
      this.etkinlikler.modal=true;
    },
    etkinlikler_iptal() {
      this.etkinlikler.secili = {};
      this.etkinlikler.islem = "";
      this.etkinlikler.modal=false;
    },
    

    etkinlikler_detay(etkinlikler) {
      this.$router.push('/etkinlikler/'+  etkinlikler.id);
    },
    etkinliklerSayfadaKayitDegistir(value) {
      this.etkinlikler.sayfadaKayit=value;
    },



    
    excelindir() {
      axiosCustom
        .get("etkinlikler/excelindir")
        .then((response) => {
        window.location.href = response.data.excelurl;

        setTimeout(() => {
          window.location.href = response.data.zipurl;
        }, 1000);

          this.$toast.success("Excel indirildi.");
        })
        .catch((error) => {
          console.error("Excel İndirme Hatası: ", error);
        });
    },
    excelmodal_ac() {
        this.excelmodal = true;
      },
    excelmodal_kapat() {
         this.excelmodal = false;
    },

    dosyaSecExcel(event) {
      this.seciliDosyalar[0]=event.target.files[0];
    },
    dosyaSecGorseller(event) {
      this.seciliDosyalar[1]=event.target.files[0];
    },
    async excelyukle() {
       
        const CHUNK_SIZE = 1024 * 1024; // 1 MB
        const totalFiles = this.seciliDosyalar.length;
        let uploadedFiles = 0;

        for (const file of this.seciliDosyalar) {
            const totalChunks = Math.ceil(file.size / CHUNK_SIZE);

            for (let chunk = 0; chunk < totalChunks; chunk++) {
            const start = chunk * CHUNK_SIZE;
            const end = Math.min(start + CHUNK_SIZE, file.size);

            const chunkData = file.slice(start, end);

            let formData = new FormData();
            formData.append("fileName", file.name);
            this.uploadFileName = file.name;
            formData.append("fileChunk", chunkData);
            formData.append("currentChunk", chunk);
            formData.append("totalChunks", totalChunks);

            try {
                await axiosCustom.post("etkinlikler/excelyukle/", formData);
                uploadedFiles++;
                this.uploadProgress = (uploadedFiles / totalFiles) * 100;
            } catch (error) {
                console.error('Dosya yükleme hatası: ', error);
                this.$toast.error('Dosya yükleme hatası');
                // Handle error
                return;
            }
            }
        }

        // Tüm dosyaların tüm chunk'ları yüklendiyse, işlemi tamamla
        this.isUploading = false;
        this.excelmodal = false;
        this.uploadProgress = 100;
        this.$toast.success("Excel Yüklendi");
        this.excelVeriIslem = true;
        this.excelyukleislem();

        
        
    },



    excelyukleislem() {
      axiosCustom
        .get("etkinlikler/excelyukleislem/"+this.excelislemadim)
        .then(response => {

          if (response.data.toplamadim !== 0) {
            this.excelprosesbar = Math.round((response.data.adim / response.data.toplamadim) * 100);
          }

          this.excelislemadim = response.data.adim;

        
          if (response.data.adim === -1) {
            // İşlem tamamlandıysa
            this.$toast.success("Excel'deki veriler yüklendi.");
            this.etkinliklerGetir();
            this.excelVeriIslem=false;
          } else {
            // İşlem devam ediyorsa
            this.excelyukleislem();
          }
        })
        .catch(error => {
          console.error('Excel yükleme hatası: ', error);
          this.$toast.error('Excel yükleme hatası');
        });
    }
    
   
  },
};
</script>
